import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Statistics from "../../../../components/Statistics/StatisticsActivityList/statistics";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ActivityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      statisticsModal: false,
      selectedActivityId: null
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    let obj = {
      user_id: this.props.user.user.id,
      ability_id: 0,
      difficulty_level_id: 0,
      year: 0,
      type_id: 0
    };

    axios
      .post(`${URL.api}activity/activity/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        for (let i = 0; i < resp.data.data.length; i++) {
          if (resp.data.data[i].private === true) {
            resp.data.data[i].private = "Sim";
          } else if (resp.data.data[i].private === false) {
            resp.data.data[i].private = "Não";
          }
        }
        this.setState(
          {
            list: resp.data.data.filter(item => [1, 3].includes(item.type_id))
          },
          () => {
            this.state.list.forEach(obj => this.renameKey(obj, "name", "nome"));
            this.state.list.forEach(obj =>
              this.renameKey(obj, "description", "descrição")
            );
            this.state.list.forEach(obj =>
              this.renameKey(obj, "type_name", "tipo")
            );
            this.state.list.map(item => {
              if (item.descrição.substring(0, 1) === "[") {
                JSON.parse(item.descrição)[0].children.map(des => {
                  if (des.text !== "") {
                    item.descrição = des.text;
                  } else {
                    item.descrição = "Sem descrição";
                  }
                });
              }
            });

            this.setState({
              loading: false
            });
          }
        );
      });
  }

  renameKey = (obj, oldKey, newKey) => {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  };

  getArray = data => {
    const header = ["id", "nome", "descrição", "tipo"];
    const arr = [header];
    data.forEach(item => {
      arr.push([item.id, item.nome, item.descrição, item.tipo]);
    });
    return arr;
  };

  downloadFileAction = async activity => {
    if (!activity.file_link) {
      toastr.warning("Atenção", "A atividade não possui arquivo para download");
      return;
    }

    try {
      const response = await fetch(activity.file_link);
      if (!response.ok) {
        toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = activity.file_name || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
    }
  };

  insertAction = () => {
    this.props.history.push("/activity/create");
  };

  // Função de exclusão atualizada
  deleteAction = async arrayRow => {
    try {
      this.setState({ loading: true });

      for (const row of arrayRow) {
        const obj = { id: row };
        await axios.post(`${URL.api}activity/activity/delete`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        });
      }

      // Atualiza lista local
      this.setState(prevState => ({
        list: prevState.list.filter(item => !arrayRow.includes(item.id)),
        loading: false
      }));

      toastr.success("Sucesso", "Prova(s) excluída(s) com sucesso!");
    } catch (error) {
      this.setState({ loading: false });
      toastr.error("Erro", "Ocorreu um erro ao tentar excluir a(s) prova(s).");
    }
  };

  allocateAction = row => {
    this.props.history.push(`/activity/allocate/${row.id}`);
  };

  reportAction = row => {
    if (row.tipo.toUpperCase() === "TV") {
      this.props.history.push(`/activity/tv/report/${row.id}`);
    } else {
      this.setState({ statisticsModal: true, selectedActivityId: row.id });
    }
  };

  getSelected = selecteds => {
    this.setState({
      // selectedQuestions: selecteds
    });
  };

  render() {
    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            activity_id={this.state.selectedActivityId}
            currentRoute={this.props.currentRoute}
            title={
              this.state.list.find(
                item => item.id === this.state.selectedActivityId
              )?.nome
            }
          />
        )}
        <div className="animated fadeIn">
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : (
            <Row>
              <Breadcrumb current={this.props.currentRoute} />
              {this.state.list ? (
                <div id="list">
                  <DataTable
                    noSort
                    list={this.state.list}
                    path="/activity/create/"
                    title="Atividades"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "nome", denomination: "Nome" },
                      { name: "descrição", denomination: "Descrição" },
                      { name: "tipo", denomination: "Tipo" }
                    ]}
                    insert
                    delete
                    insertAction={this.insertAction}
                    getSelected={this.getSelected}
                    action
                    btnEdit
                    btnAllocate
                    btnDownloadFile
                    btnReport
                    allocateAction={this.allocateAction}
                    reportAction={this.reportAction}
                    deleteAction={this.deleteAction}
                    downloadFileAction={this.downloadFileAction}
                  />
                </div>
              ) : (
                <Loading top="45" left="50" />
              )}
            </Row>
          )}
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);
